import React from 'react';
import useStyles from './Styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Hidden from '@mui/material/Hidden';
import StoreImg from './StoreImg';
import {Tools} from './Tools';
import {Owner} from './Inc';
//import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

interface Props {
    list: any[],
    owner: Owner,
    pager: any,
    jump(newPage:number):void,
}

const RequestListItem = (props:Props)=> {
    const classes = useStyles();
	
	return (
		<div id="fav_list_search">
            <Table>
                <TableHead>
                    <TableRow>
                        <Hidden smDown implementation="js">
                            <TableCell className={classes.tableHeadNowrap} align='center'>画像</TableCell>
                        </Hidden>
                        <TableCell className={classes.tableHeadNowrap} align='center'>商品名</TableCell>
                        <TableCell className={classes.tableHeadNowrap} align='center'>買いたい！人数</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
            {props.list.map( (sale:any,index:number)=>{
                const key = "sale"+index;
                return (
                    <TableRow key={key}>
                        <Hidden smDown implementation="js">
                            <TableCell className={classes.tableCellDense} align='center' style={{width:'5em'}}><StoreImg owner_id={props.owner.owner_id} img_id={sale.img_id} thumb={true} className="imgList"/></TableCell>
                        </Hidden>
                        <TableCell className={classes.tableCellDense}>
                            <span className={classes.itemId}>ID:{sale.item_id}</span><br/>
                            {sale.item_name}<br/>
                        </TableCell>
                        <TableCell className={classes.tableCellNowrap+' '+classes.requestListCount} align='right'>
							{sale.count}人
                        </TableCell>
                    </TableRow>
                );
            })}
                </TableBody>
            </Table>
            <div style={{padding:"1em"}}>
            {Tools.pager(props.pager,props.jump)}
            </div>


		</div>
	);
}

export default RequestListItem;
